<template>
  <div class="md-layout" v-if="this.model">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon>mdi-clipboard-text</v-icon>Print Prescription
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text :to="'/prescription/view/' + this.id">
              <v-icon>mdi-arrow-left</v-icon>Back
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <pdf-viewer url="prescriptions/print" :params="{ id: id }" :filename="this.filename"></pdf-viewer>
      </v-card>
    </div>
  </div>
</template>

<script>
import PdfViewer from "@components/PdfViewer.vue";
export default {
  components: {
    PdfViewer
  },
  data() {
    return {
      id: this.$route.params.id,
      model: null
    };
  },
  computed: {
    filename: function() {
      return this.model && this.model.invoiceNumber
        ? "invoice_" + this.model.invoiceNumber + ".pdf"
        : "prescription_" + this.model.id + ".pdf";
    }
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getPrescription(this.$route.params.id);
    } else {
      this.$route.push("/prescription");
    }
  },
  methods: {
    getPrescription(id) {
      this.$store
        .dispatch("prescriptions/get", {
          id: id
        })
        .then(data => (this.model = data));
    }
  }
};
</script>

<style></style>
